import type { UserManagerSettings } from 'oidc-client-ts';
import type { AuthConfig } from '../types';
import { authScopes } from './authScopes';

/** Each full-app origin keeps its callbacks local and uses the same stage identity. */
export function authSettings(config: AuthConfig, origin: string): UserManagerSettings | null {
  if (!config.issuer || !config.client_id) return null;
  return {
    authority: config.issuer.replace(/\/+$/, ''),
    client_id: config.client_id,
    redirect_uri: `${origin}/`,
    post_logout_redirect_uri: `${origin}/logout`,
    silent_redirect_uri: `${origin}/silent-renew.html`,
    response_type: 'code',
    scope: authScopes(config)
  };
}
